<template>
    <div class="parent-child">
        <div class="course-header">
            <div class="course-content">
                <div class="qtz-course"><img src="../../assets/imgs/course/parent-child-title-icon.png" alt="">亲子课</div>
                <ul class="course-detail">
                    <li>针对3-5个月的孩子，通过一系列的按摩体操、五感游戏，</li>
                    <li>刺激大脑和身体各个部位的发育，建立亲子一体感，消除婴儿出生后的紧张感，</li>
                    <li>增加孩子的安全感，给家长指引正确的育儿方向。</li>
                </ul>
            </div>
        </div>


        <div class="course-content">
            <div class="max-title" style="margin-bottom:0;border-bottom: none">
                <span>特色环节</span>
                <span>Characteristic games</span>
            </div>

            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">亲子想象</button>
                </div>
            </div>
            
            <ul class="flexBox">
                <li class="tag-text">通过心理暗示,建立良好的氛围。让家长放松地进行关于宝宝未来的主题想象,加强亲子一体感,帮助家长和宝贝调整情绪,更好地进入课程。</li>
                <li><img src="../../assets/imgs/course/parent-child-1.png" alt=""></li>
            </ul>

            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">五感游戏</button>
                </div>
            </div>

            <ul class="flexBox" style="align-items: center">
                <li class="tag-text">
                    <div>
                        <span style="width: 14px;height: 14px;background: #F19EB4;border-radius: 50%;display: inline-block;margin-right: 10px;"></span><span style="font-weight: 600;color: #5C5959">触摸板</span>
                    </div>
                    <div>通过让宝宝触摸各种不同的材质,</div>
                    <div>增强触觉体验。</div>
                </li>
                <li><img src="../../assets/imgs/course/parent-child-2.png" alt=""></li>
            </ul>

            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn" style="width: 200px;">黑白卡&彩色卡</button>
                </div>
            </div>

            <ul class="flexBox" style="align-items: center">
                <li class="tag-text">
                    <div>根据这个年龄宝宝视觉发展研究结果,准备各种适合的图片</div>
                    <div>(黑白图、同心圆等),引导宝宝进行视觉追踪。</div>
                </li>
            </ul>

            <ul class="flexBox" style="align-items: center">
                <li class="tag-text">
                    <div>
                        <span style="width: 14px;height: 14px;background: #F19EB4;border-radius: 50%;display: inline-block;margin-right: 10px;"></span><span style="font-weight: 600;color: #5C5959">方格卡&同心圆卡&彩色卡</span>
                    </div>
                </li>
            </ul>

            <ul class="flexBox" style="align-items: center;margin-top: 30px">
                <li><img src="../../assets/imgs/course/parent-child-3.png" alt=""></li>
                <li><img src="../../assets/imgs/course/parent-child-4.png" alt=""></li>
                <li><img src="../../assets/imgs/course/parent-child-5.png" alt=""></li>
            </ul>

            <div class="content-item" style="margin-top: 60px">
                <div class="content-title">
                    <button class="page-btn">按摩体操</button>
                </div>
            </div>

            <ul class="flexBox" style="align-items: center;">
                <li class="tag-text">
                    <div>指导家长练习婴儿按摩和体操,帮助宝宝降低焦虑和压力,增强免疫能力、灵活</div>
                    <div>反应力,改善睡眠,促进宝宝吸收、循环以及运动功能的协调发展。</div>
                </li>
            </ul>

            <ul style="margin: 60px 0">
                <li>
                    <img src="../../assets/imgs/course/parent-child-6.png" style="margin-right: 40px" alt="">
                    <img src="../../assets/imgs/course/parent-child-7.png" alt="">
                </li>
            </ul>

        </div>
    </div>
</template>

<script>
    export default {
        name: "parent-child",
        data(){
            return {

            }
        }
    }
</script>

<style scoped lang="less">
    .parent-child{
        .course-header{
            background-image: url("../../assets/imgs/course/parent-child-bg.png");
        }
        .max-title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #F19EB4;
            margin-bottom: 15px;
            span:first-child{
                font-weight: 600;
                font-size: 35px;
            }
            span:last-child{
                font-size: 20px;
            }
        }
        .content-item{
            margin-bottom: 20px;
            border-top: 1px solid #F19EB4;
            .page-btn{
                width: 150px;
                height: 40px;
                font-weight: 600;
                font-size: 20px;
                background: #F19EB4;
                color: #fff;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                border: none;
                outline: none;
            }
        }
        .tag-text{
            padding-top: 30px;
            font-size: 16px;
            font-family: Light;
            color: #8D8C8B;
            line-height: 1.8;
        }
    }
</style>